
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface MegaMenuItemProps {
  icon: LucideIcon;
  title: string;
  description: string;
  className?: string;
}

export const MegaMenuItem = ({ 
  icon: Icon, 
  title, 
  description, 
  className 
}: MegaMenuItemProps) => {
  return (
    <div 
      className={cn(
        "flex items-start p-4 hover:bg-gray-50 rounded-lg transition-colors",
        className
      )}
    >
      <Icon 
        className="h-6 w-6 text-edgefi-purple mt-1 mr-4 flex-shrink-0" 
        aria-hidden="true" 
      />
      <div>
        <h3 className="font-semibold text-gray-900 mb-1">{title}</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default MegaMenuItem;
